import { CacheableDataObject } from './CacheableDataObject';
import moment from 'moment';

export default class UserNote extends CacheableDataObject {

}
UserNote.prototype.dataLocationParsers = {
	time: (note, data) => {
		note.time = moment.unix(data.time.timestamp);
	}
};